var map = {
	"./_Github.svg": "7d9a",
	"./_Whatsup.svg": "f62e",
	"./_facebook.svg": "1fcf",
	"./_twitter.svg": "3246",
	"./address.svg": "25c4",
	"./down.svg": "1a4e",
	"./facebook.svg": "ca4d",
	"./github.svg": "cda1",
	"./logo.svg": "d9b6",
	"./logobottom.svg": "ba98",
	"./phone.svg": "b470",
	"./query.svg": "3af0",
	"./twitter.svg": "6bde",
	"./up.svg": "bc3e",
	"./whatsup.svg": "fef5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";